import { render, staticRenderFns } from "./WebHookManagement.vue?vue&type=template&id=13513064&"
import script from "./WebHookManagement.vue?vue&type=script&lang=js&"
export * from "./WebHookManagement.vue?vue&type=script&lang=js&"
import style0 from "./WebHookManagement.vue?vue&type=style&index=0&id=13513064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports